// Polyfill for Safari/iOS - requestIdleCallback not supported
if (typeof window !== 'undefined' && !('requestIdleCallback' in window)) {
  (window as any).requestIdleCallback = function(cb: any) {
    const start = Date.now();
    return setTimeout(function() {
      cb({ didTimeout: false, timeRemaining: function() { return Math.max(0, 50 - (Date.now() - start)); } });
    }, 1);
  };
  (window as any).cancelIdleCallback = function(id: any) { clearTimeout(id); };
}

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
